import { useEffect, useMemo } from 'react'
import { useParams } from 'wouter'
import { useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

import { CategoryForm } from '@/features/layout'
import { DialogHeader } from '@/layouts/Dialog'
import { useCloseModal } from '@/Router'
import { Suspense } from '@/components/ui/Suspense'
import { useLingui } from '@lingui/react/macro'

function CreateCategory({ layoutVersion }: { layoutVersion: number }) {
  const { t } = useLingui()
  const closeModal = useCloseModal()

  const { data } = useSuspenseQuery(AdminAPI.layout.GET_BY_VERSION, {
    variables: { version: layoutVersion }
  })

  const layout = useMemo(
    () =>
      getFragment(SharedAPI.layout.LAYOUT_FRAGMENT, data.getLayoutByVersion),
    [data]
  )

  return (
    <div className="flex flex-col gap-7 p-5">
      <DialogHeader
        title={t`Create Category`}
        description={t`Creation of a new category for the currently selected layout.`}
      />
      <CategoryForm
        onCancel={closeModal}
        onDone={closeModal}
        layoutId={layout.id}
      />
    </div>
  )
}

export default function CreateCategorySuspense() {
  const closeModal = useCloseModal()
  const params = useParams() as { layoutVersion: string }

  useEffect(() => {
    if (!params) closeModal()
  }, [closeModal, params])

  if (!params) return null

  return (
    <Suspense isDialog>
      <CreateCategory layoutVersion={parseInt(params.layoutVersion)} />
    </Suspense>
  )
}
